export default __webpack_public_path__ + "static/media/asana.b85b782d.png";